angular.module('aprima-core-ui').factory('inputSelection', [ 
    function() {
        'use strict';
    
        return {
            getChildElement: getChildElement,
            trySelectStr: trySelectStr,
        };
        
        function getChildElement(element) {
            var childElement = element[0];
            if(!childElement.setSelectionRange) {
                throw new Error('inputSelection won\'t work with ' + childElement + ' because it doesn\'t' +
                    ' support \'setSelectionRange\'');
            }
            return childElement;
        }
        
        function trySelectStr(element, ngModelCtrl, str, startIndex) {
            if(!element || !ngModelCtrl) {
                return false;
            }
            startIndex = startIndex || 0;
            
            var viewValue = ngModelCtrl.$viewValue &&  ngModelCtrl.$viewValue.toString();
            if(viewValue) {
                var index = viewValue.indexOf(str, startIndex);
                if(index !== -1) {
                    element.setSelectionRange(index, index + str.length);
                    return true;
                }
            }
            return false;
        }
    }
]);